import API_ROUTES from "app/constants/routes/api";
import Api from '../../../../api/Api'
import { apiParams } from "app/utils/javascript";

export const getJobDatApi = async ({ payload }) => {
    const response = await Api.post(API_ROUTES.GET_SINGLE_JOB_API, payload);
    return response;
};

export const retryCertApi = async ({ payload }) => {
    const response = await Api.post(API_ROUTES.RETRY_CERT, payload);
    return response;
};

export const retryCertStatusApi = async ({ reportId }) => {
    const response = await Api.patch(API_ROUTES.RETRY_CERT_STATUS(reportId));
    return response;
};

export const getJobIdApi = async ({ payload }) => {
    const response = await Api.post(API_ROUTES.CREATE_JOB_API, payload);
    return response;
}

export const deleteCylinderApi = async ({ payload }) => {
    const response = await Api.delete(API_ROUTES.UPDATE_CYLINDER_JOB, { data: payload });
    return response;
}

export const getCylindersLotList = async ({ pageNo }) => {
    const response = await Api.get(API_ROUTES.GET_CYLINDERS_LOT_LIST(pageNo));
    return response;
}

export const getCylindersList = async ({ payload, pageNo }) => {
    const response = await Api.post(API_ROUTES.GET_NEW_CYLINDER(pageNo), payload);
    return response?.data;
}

export const updateJobs = async ({ payload, type }) => {
    try {
        return await Api[type](API_ROUTES.UPDATE_JOBS, payload);
    } catch (error) {
        return error
    }
}

export const deleteLotApi = async ({ payload }) => {
    const response = await Api.delete(API_ROUTES.UPDATE_PROCESS_JOBS, { data: payload });
    return response;
}

export const deleteConnectedRecoveryApi = async ({ payload }) => {
    const response = await Api.delete(API_ROUTES.UPDATE_PROCESS_JOBS, { data: payload });
    return response;
}

export const addManualCertificateApi = async ({ payload }) => {
    const response = await Api.post(API_ROUTES.MANUAL_CERTIFICATE, payload);
    return response;
};

export const deleteManualCertificateApi = async ({ certificateId }) => {
    const response = await Api.delete(API_ROUTES.DELETE_MANUAL_UPLOAD(certificateId));
    return response;
};

export const getMostUsedUsers = async ({ payload }) => {
    const response = await Api.get(API_ROUTES.GET_MOST_USED_USERS(payload));
    return response;
}

export const scanCylinderIdApi = async ({ payload }) => {
    const response = await Api.post(API_ROUTES.SCAN_OCR, payload);
    return response?.data;
}

export const getBrandProductModel = async ({ payload, pageNo }) => {
    const response = await Api.post(API_ROUTES.GET_BRAND_MODEL(pageNo), payload);
    return response?.data;
}
export const searchBrandProductModel = async ({ pageNo, payload }) => {
    const response = await Api.post(API_ROUTES.SEARCH_BRAND_PRODUCT(pageNo), payload);
    return response?.data;
}
export const editLogAPI = async ({ payload }) => {
    const response = await Api.patch(API_ROUTES.EDIT_LOG, payload);
    return response?.data;
}

export const editLogHistoryAPI = async ({ params, pageNo }) => {
    const response = await Api.get(API_ROUTES.EDIT_LOG_HISTORY({ params: apiParams({ params, pageNo }) }));
    return response?.data;
}

export const getBorrowedTransferCylinder = async ({ payload, pageNo }) => {
    const response = await Api.post(API_ROUTES.GET_NEW_CYLINDER(pageNo), payload);
    return response?.data;
}
export const getSearchByIdCylinder = async ({ payload, pageNo }) => {
    const response = await Api.post(API_ROUTES.GET_CYLINDER_BY_ID(pageNo), payload);
    return response?.data;
}

export const getColumnFilterAPI = async ({ params }) => {
    const response = await Api.get(API_ROUTES.GET_COLUMN_FILTER({ params: apiParams({ params }) }));
    return response?.data;
}

export const addJobFilterAPI = async ({ payload }) => {
    const response = await Api.post(API_ROUTES.ADD_JOB_FILTER, payload);
    return response?.data;
}

export const getCylindersInfoList = async ({ cylinderNames }) => {
    const names = Array.isArray(cylinderNames) ? cylinderNames.join(',') : cylinderNames;
    const response = await Api.get(API_ROUTES.GET_CYLINDER_INFO_LIST({ cylinderName: names }));
    return response?.data;
}
export const processJobProcessingApi = async ({ payload }) => {
    const response = await Api.post(API_ROUTES.PROCESS_JOB_PROCESSING, payload);
    return response?.data;
}

export const getCylinderListApi = async ({ page, payload }) => {
    const response = await Api.post(API_ROUTES.GET_CYLINDER_LIST_V2(page), payload);
    return response?.data;
}

export const getEntryMethodApi = async ({ payload }) => {
    const response = await Api.get(API_ROUTES.GET_ENTRY_METHOD({ payload: apiParams({ params: payload }) }));
    return response?.data;
}

export const markAllReadJobsApi = async ({ payload }) => {
    const response = await Api.post(API_ROUTES.MARK_ALL_READ, payload);
    return response?.data;
}
